import React from "react";
import "../../src/Css/Sponsors.css";
import { Link } from "react-router-dom";

// Import static images
import sponsor1 from "D:/Abhi2/my-app/src/images/Sponsor.png";
import sponsor2 from "D:/Abhi2/my-app/src/images/Sponsor.png";
import sponsor3 from "D:/Abhi2/my-app/src/images/Sponsor.png";
import sponsor4 from "D:/Abhi2/my-app/src/images/Sponsor.png";
import sponsor5 from "D:/Abhi2/my-app/src/images/Sponsor.png";

const sponsors = [
  { id: 1, imgSrc: sponsor1 },
  { id: 2, imgSrc: sponsor2 },
  { id: 3, imgSrc: sponsor3 },
  { id: 4, imgSrc: sponsor4 },
  { id: 5, imgSrc: sponsor5 },
];

const Sponsors = () => {
  return (
    <div className="container">
      <h1 className="sponsors">Sponsors &amp; Supporters</h1>
      <div className="sponsors_supporters_maxheight">
        <div className="sponsors_wrapper">
          {sponsors.map((sponsor) => (
            <div key={sponsor.id} className="sponsor-item">
              <div className="boxarea1">
                <Link>
                  <img src={sponsor.imgSrc} alt="Sponsor" />
                </Link>
              </div>
              <p style={{ textAlign: "center" }}></p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Sponsors;
